import { render, staticRenderFns } from "./HeaderStaff.vue?vue&type=template&id=fa99650e&"
import script from "./HeaderStaff.vue?vue&type=script&lang=js&"
export * from "./HeaderStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports